<template>
  <v-col row @keyup.13="login()">
    <v-col
      lg="12"
      md="12"
      cols="12"
      class="title py-0 font-weight-bold"
      v-text="'Login'"
    ></v-col>
    <v-col
      lg="12"
      md="12"
      cols="12"
      class="grey--text"
      v-text="'Please enter your registered email and password to sign in.'"
    ></v-col>
    <v-col md="12">
      <span class="error--text">{{
        formValidator.getError("non_field_errors")
      }}</span>
      <v-form ref="form">
        <v-text-field
          v-model="loginDetails[rhrCoreShellOptions.loginUserFieldName]"
          type="text"
          :label="rhrCoreShellOptions.loginUserLabel"
          :prepend-inner-icon="rhrCoreShellOptions.loginUserAppendIcon"
          autocomplete="email"
          :error-messages="
            formValidator.getError(rhrCoreShellOptions.loginUserFieldName)
          "
        ></v-text-field>

        <v-text-field
          v-model="loginDetails.password"
          label="Password"
          :append-icon="
            passwordShow ? $getIcon('mdiEye') : $getIcon('mdiIconOff')
          "
          :type="passwordShow ? 'text' : 'password'"
          :prepend-inner-icon="$getIcon('mdiAccount')"
          autocomplete="password"
          @click:append="passwordShow = !passwordShow"
          :error-messages="formValidator.getError('password')"
        ></v-text-field>
      </v-form>
    </v-col>
    <v-col lg="12" md="12" cols="12" class="py-0">
      <v-row align="center" class="py-0 my-0">
        <v-col class="py-0">
          <v-checkbox id="rememberMe" :label="'Remember'"></v-checkbox>
        </v-col>
        <v-col class="text-right py-0">
          <v-btn
            id="forgetPassword"
            router
            class="grey--text caption"
            text
            small
          >
            Forget Password
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col md="12">
      <v-btn
        id="logInButton"
        :loading="loading"
        depressed
        small
        color="primary"
        @click="login"
      >
        Sign In
      </v-btn>
      <v-btn
        :loading="loading"
        depressed
        small
        color="primary ml-2"
        @click="$auth.loginWith('realHrSoft')"
      >
        Sign In with RealHRSoft
      </v-btn>
    </v-col>
  </v-col>
</template>

<script>
import { mapMutations } from "vuex";
import { FormValidator } from "../../";

export default {
  auth: false,
  data() {
    return {
      rhrCoreShellOptions: {},
      loading: false,
      htmlTitle: "Login",
      loginDetails: {},
      passwordShow: "",
      notify: {},
      formValidator: new FormValidator()
    };
  },
  mounted() {
    this.rhrCoreShellOptions = window.rhrCoreShellOptions;
    document.title = `${this.$rhrCoreShellOptions.name} | Login`;
  },
  beforeDestroy() {
    document.title = `${this.$rhrCoreShellOptions.name}`;
  },
  methods: {
    ...mapMutations({
      updateAuthToken: "updateAuthToken"
    }),
    async login() {
      this.$auth
        .loginWith("local", { data: this.loginDetails })
        .then(() => {
          this.$store.dispatch("shell/showSnackbar", {
            text: `Welcome to ${window.rhrCoreShellOptions.name}!`,
            color: "red"
          });
        })
        .catch(error => {
          this.formValidator.setError(error.response.data);
        });
    },
    clearForm() {
      this.email = "";
      this.password = "";
    }
  }
};
</script>
